import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';

const _SelectAlertOptionRequestDtoSchema = z.object({
  id: z.number(),
  selectedOptionId: z.number(),
});

export type SelectAlertOptionRequestDto = z.infer<
  typeof _SelectAlertOptionRequestDtoSchema
>;

export const selectAlertOption = (
  params: SelectAlertOptionRequestDto,
  config?: AxiosRequestConfig<SelectAlertOptionRequestDto>
) => {
  const { id, ...option } = params;

  return api.patch(`alerts/${id}/select-option`, option, {
    ...config,
  });
};
